import { render } from "./providerLogin.vue?vue&type=template&id=795e8e1a&ts=true"
import script from "./providerLogin.vue?vue&type=script&lang=ts"
export * from "./providerLogin.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__